import { Box, Typography } from '@mui/material';
import ReusableTabs from '../UIElements/ReusableTabs';
import HistoryIcon from '@mui/icons-material/History';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import { GrCertificate } from 'react-icons/gr';
import StudentHistory from './StudentHistory';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import TCPage from './TCPage';
import SCPage from './SCPage';
import { useSelector } from 'react-redux';
function HistoryPage() {
  const loginData = useSelector((state) => state.auth.successData);
  console.log(loginData);
  const location = useLocation();
  const [ActiveTab, setActiveTab] = useState(0);
  const HistoryTabs = [
    {
      label: 'Student History',
      icon: <HistoryIcon className='size-8 ' />,
      content: <StudentHistory />,
    },
    // {
    //   label: 'Transfer Certificate',
    //   icon: <CardMembershipIcon className='size-8 ' />,
    //   content: <TCPage />,
    // },
    // {
    //   label: 'Study Certificate',
    //   icon: <GrCertificate className='size-8 ' />,
    //   content: <SCPage />,
    // },
    (loginData?.userDetails?.instituteName?.trim()?.toUpperCase() ===
      'SRI VEERISETTY JUNIOR COLLEGE' ||
      loginData?.userDetails?.instituteName?.trim()?.toUpperCase() ===
        'BELLAMKONDA DEGREE COLLEGE') && {
      label: 'Transfer Certificate',
      icon: <CardMembershipIcon className='size-8 ' />,
      content: <TCPage />,
    },
    (loginData?.userDetails?.instituteName?.trim()?.toUpperCase() ===
      'SRI VEERISETTY JUNIOR COLLEGE' ||
      loginData?.userDetails?.instituteName?.trim()?.toUpperCase() ===
        'BELLAMKONDA DEGREE COLLEGE') && {
      label: 'Study Certificate',
      icon: <GrCertificate className='size-8 ' />,
      content: <SCPage />,
    },
  ].filter(Boolean);
  useEffect(() => {
    if (location?.state?.defaultValue !== undefined)
      setActiveTab(location?.state?.defaultValue);
  }, [location]);
  return (
    <>
      <Box className='p-4'>
        <Box className='bg-blue-50 p-4 rounded-lg'>
          <Typography variant='h6' className='text-blue-700 font-bold'>
            Manage Past Details of Students
          </Typography>
          <Typography variant='body1' className='text-gray-600'>
            Handle student past data,migrations etc...
          </Typography>
        </Box>
        <ReusableTabs
          tabs={HistoryTabs}
          variant='scrollable'
          allowScrollButtons={true}
          defaultTab={ActiveTab}
          className='w-full'
        />
      </Box>
    </>
  );
}
export default HistoryPage;
